import { render, staticRenderFns } from "./UnitsPagesContainer.vue?vue&type=template&id=9c9eabd0&"
import script from "./UnitsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./UnitsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports